import React from 'react';
import { Redirect } from 'react-router-dom';
import { Box } from '@nimbus-ds/components';
import { ROUTES } from 'App/Routes/constants';
import { InstallationStatusAlert } from 'commons/components';
import {
  useInstallationStatusAlertVisibility,
  useMexicoEmptyState,
} from 'commons/hooks';
import Home from '../../../Home';
import HomeSkeleton from '../../../HomeSkeleton';
import { useHomeMexico } from '../../hooks';

function HomeMexico(): JSX.Element {
  const { isLoading, shouldRedirectLanding } = useHomeMexico();
  const { emptyState, isLoading: isLoadingEmptyState } = useMexicoEmptyState();
  const { isVisible, dismiss } = useInstallationStatusAlertVisibility({
    messageCode: emptyState.messageCode,
    status: emptyState.status,
  });

  const getAlertsComponent = () => {
    if (!emptyState.alertEnabled || !isVisible) {
      return null;
    }

    return (
      <Box marginBottom="8">
        <InstallationStatusAlert
          status={emptyState.status}
          show={isVisible}
          requestDate={emptyState.requestDate}
          messageCode={emptyState.messageCode}
          messageSeverity={emptyState.messageSeverity}
          nextActionCode={emptyState.nextActionCode}
          deadline={emptyState.deadline}
          handleClick={emptyState.handleClick}
          onRemove={dismiss}
        />
      </Box>
    );
  };

  if (isLoading || isLoadingEmptyState) {
    return <HomeSkeleton />;
  }

  if (shouldRedirectLanding) {
    return <Redirect to={ROUTES.LANDING} />;
  }

  return <Home alertsComponent={getAlertsComponent()} />;
}

HomeMexico.Skeleton = HomeSkeleton;
export default HomeMexico;
